/*
 * Application Messages
 *
 * This contains all the text for the Application component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  websiteTitle: {
    id: 'cwt.translations.Application.WebsiteTitle',
    defaultMessage: 'Custom Worktop Calculator',
  },
});
